import { MediaGestureReceiver } from 'media-chrome';

/**
 * Gesture receiver that also toggles playback on a touch tap.
 *
 * Media Chrome's own receiver deliberately does nothing on touch — `handleTap` is an
 * empty abstract method, and only mouse and pen reach `handleMouseClick`. Where there is
 * a control bar that is survivable, because the tap reveals the bar and the viewer
 * presses pause there. When the big play button is the only control it is hidden during
 * playback (`media-controller:not([mediapaused]) .large-play { display: none }`), so a
 * touch viewer has no way at all to pause (STREAM-843).
 *
 * The server slots this element only in that configuration, so players with a control
 * bar keep the stock behaviour of revealing controls rather than pausing on tap.
 */
export class BunnyGestureReceiver extends MediaGestureReceiver {
  override handleTap(event: Event): void {
    this.handleMouseClick(event);
  }
}

if (!globalThis.customElements.get('bunny-gesture-receiver')) {
  globalThis.customElements.define(
    'bunny-gesture-receiver',
    BunnyGestureReceiver,
  );
}

export default BunnyGestureReceiver;
